import { call, put, takeEvery } from "redux-saga/effects";
import { api } from "Shared/axios";
import { getReqHeader } from "Shared/helpers";
import { userMailsActions } from "./user_mails.slice";

function* fetchMails() {
	const headers = yield call(getReqHeader);
	try {
		const { data: list } = yield call(api.get, "/email", headers);
		const confirmed = yield call(isChecked, list);
		yield put(userMailsActions.set({ list, confirmed }));
	} catch (error) {
		yield console.error("checkMails", error);
		yield put(userMailsActions.set({ list: [], confirmed: false }));
	}
}

function isChecked(arr = []) {
	return arr.some((item) => item.is_verified);
}

function* sendMail({ payload: email }) {
	try {
		const headers = yield call(getReqHeader);
		yield call(api.post, "/email/verification", { email }, headers);
	} catch (error) {
		yield console.error("sendMail", error);
	}
}

export function* watchUserMails() {
	yield takeEvery(userMailsActions.get, fetchMails);
	yield takeEvery(userMailsActions.sendMail, sendMail);
}
